import config from '../../config';
import { useContext, useEffect, useState } from 'react';
import UploadGrid from './UploadGrid';
import ProofDialog from './ProofDialog';
import ImageUpload from './ImageUpload';
import PdfUpload from './PdfUpload';
import { documentTypePerName } from './helper';
import { Il8nContext } from '../../Helper/i18n';
import axios from '../../Helper/Axios/interceptor';
import MySnackbarContentWrapper from '../../Components/Snackbars';
import { useMediaQuery, useTheme, Snackbar, DialogContent, Dialog, DialogTitle, Typography, Grid, Button } from '@mui/material';
import FullScreenLogoLoader from '../../Components/FullScreenLoader';
import Popup, { PopupTitle } from '../CustomPopup';
import UploadVideo from './UploadVideo';
import PhotoProofDialog from '../DocumentUpload/PhotoProofDialog';
import getCookie from '../../Helper/Cookies/cookies';
import FullScreenLoader from '../../Components/FullScreenLoader';
function Upload(props) {
  const theme = useTheme();
  const isSmallScreen = useMediaQuery(theme.breakpoints.down('md'))

  let ipvDocument = []

  const { title, documentOptionData, masterId, uploadedDocuments, setUploadedDocuments,isRequired, documentData, getFilteredDocs,
    isAddressPage,setOcrUploadLoading,ocrUploadLoading,ipvPhoto, setIpvPhoto ,limitPdfPages,getAllAdressData, isAddressDetails, accountOpeningType } = props;
  const { id, type, code, screen } = documentOptionData || {};

  const [proofs, setProofs] = useState({});
  const [loading, setLoading] = useState(false)
  const [snackBar, setSnackBar] = useState({})
  const [proofType, setProofType] = useState({})
  const [popupType, setPopupType] = useState("");
  const [uploadMessagePopup, setUploadMessagePopup] = useState(false)
  const [documentUploadedDetails, setDocumentUploadedDetails] = useState([])
  const [selectedDocumentMasterData, setSelectedDocumentMasterData] = useState({})
  const [documentMandatoryDetails, setDocumentMandatoryDetails ] = useState([])
  const [docUploadLoading,setDocUploadLoading] = useState(false)
  const [ocrLoader,setOcrLoader] = useState(false)
  const localeText = useContext(Il8nContext)
  const [showFailPopup, setShowFailPopup] = useState({
      "showPopup":false,
      "showPopupMessage":""
  })
  useEffect(() => {
    setProofType({ id, type, code, screen })
    getAllUploadedDocuments()
  }, []);

  useEffect(() => {
    if(ipvPhoto && props.typeCode === 'Photo') {
      setProofs({ proofType: 'image', data: ipvPhoto?.images })
      setDocumentUploadedDetails(ipvPhoto?.documentArr)
    }
  }, [ipvPhoto])

  var positionData;
  navigator.geolocation.getCurrentPosition((position) => {
    positionData = {
        latitude: position.coords.latitude,
        longitude: position.coords.longitude,
    }
  })
  function getDocument(payload) {
    return new Promise(function (resolve) {
      axios.post(process.env.REACT_APP_API_URL + config.getDocument, payload).then(resp => {
        if (resp.data.success?.[0]) {
          resolve(resp.data.success[0])
        } else {
          resolve({})
        }
      }).catch(error => {
        resolve({})
      })
    });
  }

  function getSelectedDocumentMasterData(id) {
    if (id) {
      axios.get(process.env.REACT_APP_API_URL + config.documentMaster + (masterId || '2')).then(resp => {
        if (resp.data.success?.documentsReq?.length > 0) {
          let data = resp.data.success.documentsReq.find(ele => ele.id === id) || {}
          setSelectedDocumentMasterData(data)
        }
      }).catch(error => {
      })
    }
  }

  function getAllUploadedDocuments() {
    if (uploadedDocuments?.length > 0) {
      setLoading(true)
      let apiPayloadArray = [];
      uploadedDocuments.forEach(doc => {
        apiPayloadArray.push(getDocument({ id: doc.kycstgProofId, productType: "diy" }))
      })
      Promise.all(apiPayloadArray).then(response => {
        let documents = {}, uploadedDocuments = []/* ,mandatoryData=[]; */
        if (response[0]?.fileType === "pdf") {
          response.forEach(data => {
            if (data.fileType === "pdf") {
              documents = { proofType: "pdf", data: "data:application/pdf;base64," + data.base64Format }
              uploadedDocuments.push({
                documentTypeCode: data.documentTypeCode,
                kycstgProofId: data.id,
                documentSubType: data.documentSubType,
                documentId: data.documentId,
                documentScreen: "",
                documentName: data.documentName || "",
                documentNumber : data.documentNumber,
                documentExpiryDate: data.documentExpiryDate
              })
            }
          })
          getSelectedDocumentMasterData(response[0].documentId)
        } else if (response[0]?.documentTypeCode === "IPV") {
          response.forEach(data => {
            if (data.fileType === "mp4") {
              documents = { proofType: "video", data: "data:video/" + data.fileType + ";base64," + data.base64Format }
              uploadedDocuments.push({
                documentTypeCode: data.documentTypeCode,
                kycstgProofId: data.id,
                documentSubType: data.documentSubType,
                documentId: data.documentId,
                documentScreen: "",
                documentName: data.documentName || "",
              })
            }
          })
        } else {
          let images = [];
          response.forEach(data => {
            if (Object.keys(data).length > 0) {
              images.push("data:image/" + data.fileType + ";base64," + data.base64Format)
              // mandatoryData.push({ documentNumber:data.documentNumber,documentExpiryDate:data.documentExpiryDate })
              uploadedDocuments.push({
                documentTypeCode: data.documentTypeCode,
                kycstgProofId: data.id,
                documentSubType: data.documentSubType,
                documentId: data.documentId,
                documentScreen: "",
                documentName: data.documentName || "",
                documentNumber : data.documentNumber,
                documentExpiryDate: data.documentExpiryDate
              })
            }
          })
          if (images.length > 0) {
            getSelectedDocumentMasterData(response[0]?.documentId)
            documents = { proofType: "image", data: images }
          }
        }
        // setDocumentMandatoryDetails(mandatoryData)
        setLoading(false)
        setProofs(documents)
        setDocumentUploadedDetails(uploadedDocuments)
        setUploadedDocuments(uploadedDocuments)
      })
    }
  }
  
  function deleteDocument(id) {
    setLoading(true)
    axios.post(process.env.REACT_APP_API_URL + config.deleteDocument, { productType: "diy", id }).then(response => {
      if (response.data.success) {
        if(documentData?.length > 0){
        documentData?.filter(item => !item.isOptional && item?.documentTypeCode == documentOptionData?.id).forEach(doc =>{
          if(doc.kycstgProofId == null ||  doc.kycstgProofId.includes(`${id}`) && doc.kycstgProofId.length == 1){
            doc.isUploaded = false;
            doc.kycstgProofId=null
          }else if(doc.kycstgProofId.length >= 1){
            doc.isUploaded = true;
            doc.kycstgProofId=doc.kycstgProofId.filter(item =>item != id)
          }
        })
        getFilteredDocs(documentOptionData?.id, documentData)
      }
        setSnackBar({ show: true, message: response.data.success, type: 'success' })
        code == "Photo" && handleClose()
      } else {
        setSnackBar({ show: true, message: response.data.error || localeText?.uploadErrorDeleting, type: 'error' })
      }
      setLoading(false)
    }).catch(error => {
      setLoading(false)
    })
  }

  function uploadDocument(data, images) {
    setLoading(false)
    setDocUploadLoading(true)
    let documentArr = [...documentUploadedDetails];
    data.forEach(document => {
      let payload = {...document}
      if(payload.isIPV) {
        delete payload.isIPV
      }
      axios.post(`${process.env.REACT_APP_API_URL}${config.uploadDocument}`, payload).then(response => {
        if (response.data.success) {
          if(documentData?.length > 0){
            documentData?.forEach(doc => {
              if(doc.documentTypeCode == data[0]?.docTypeCode){
                doc.isUploaded = true;
                doc.kycstgProofId= doc.kycstgProofId ? [...doc.kycstgProofId,`${response.data.success[0]?.id}`]: [`${response.data.success[0]?.id}`]
              }
            });
            getFilteredDocs(documentOptionData?.id, documentData)
          }
          var docNotUploaded = response.data.success.find(docResponse => docResponse.Status == false)
          if (docNotUploaded) {
            setSnackBar({ show: true, message: `${localeText?.uploadUnableUpload}${docNotUploaded.uploadId}`, type: 'error' })
          } else {
            documentArr = [...documentArr, {
              documentTypeCode: data[0]?.isIPV ? "Photo" : proofType.id,
              kycstgProofId: response.data.success[0].id,
              documentSubType: proofType.type,
              documentId: selectedDocumentMasterData.id || "",
              documentScreen: proofType.screen,
              documentName: selectedDocumentMasterData.documentName || "",
              documentNumber : document.documentNumber,
              documentExpiryDate: document.documentExpiryDate,
              ...(response?.data?.success[0]?.ocrDetails && Object.keys(response?.data?.success[0]?.ocrDetails)?.length > 0 ? {ocrDetails:response?.data?.success[0]?.ocrDetails} : {})
            }]
            ipvDocument = [...ipvDocument, {
              documentTypeCode: data[0]?.isIPV ? "Photo" : proofType.id,
              kycstgProofId: response.data.success[0].id,
              documentSubType: proofType.type,
              documentId: selectedDocumentMasterData.id || "",
              documentScreen: proofType.screen,
              documentName: selectedDocumentMasterData.documentName || "",
              documentNumber : document.documentNumber,
              documentExpiryDate: document.documentExpiryDate,
              ...(response?.data?.success[0]?.ocrDetails && Object.keys(response?.data?.success[0]?.ocrDetails)?.length > 0 ? {ocrDetails:response?.data?.success[0]?.ocrDetails} : {})
            }]
            setDocUploadLoading(false)
            setDocumentUploadedDetails(documentArr)
            if(data[0]?.isIPV) {
              setIpvPhoto({ documentArr, images })
              setUploadedDocuments(ipvDocument)
            } else {
              setUploadedDocuments(documentArr)
            }
            if (proofs.proofType === "image") {
              setUploadMessagePopup(true)
            } else {
              setSnackBar({ show: true, message: localeText?.uploadUploadedSucc, type: 'success' })
              handleClose()
            }
          }
        } else {
          setLoading(false)
          setSnackBar({ show: true, message: response.data.error || '', type: 'error' })
          setDocUploadLoading(false)
        }
      }).catch(exception => {
        setDocUploadLoading(false)
        setSnackBar({ show: true, message: exception.message || '', type: 'error' })
      })
    })
  }

  function deleteImage(data, index) {
    if (data?.length > 0) {
      setProofs({ proofType: "image", data })
    } else {
      setProofs({})
    }
    if (documentUploadedDetails?.[index]) {
      let uploaded = [...documentUploadedDetails]
      uploaded.splice(index, 1)
      deleteDocument(documentUploadedDetails[index].kycstgProofId)
      setDocumentUploadedDetails(uploaded)
      setUploadedDocuments(uploaded)
     }
  }

  function handleDocumentPopup(id) {
    if(id === "Photo"){
      setPopupType("livePhotoPopup")
    } 
    else{
      setPopupType("master")      
    }
  }

  function openDocumentMasterPopup() {
    setPopupType("master")
  }

  function toggleIPVPopup() {
    setPopupType("video")
  }

  function handleClose() {
    setPopupType("")
  }

  function onFile(file) {
    setPopupType("")
    if (file.type.includes("pdf")) {
      setPopupType("pdf")
      setProofs({ proofType: "pdf", ...file || {} })
    } else {
      setPopupType("image")
      setProofs({ proofType: "image", data: [file.data] })
    }
  }

  function uploadImageProof(images, index, documentNumber, documentExpiryDate, latitude, longitude, isPhoto, data, isOcrRequired ,isIPV) {
    if (images && images.length > 0) {
      let outData = [images[index]].map((dt, i) => dt && ({
        pageNo: (index + 1),
        pan: "",
        uploadId: (index + 1),
        docTypeCode: isIPV ? "Photo" : proofType.id,
        docMId: isIPV ? "33" : selectedDocumentMasterData.id,
        type: proofType.type,
        objectionId: "",
        fileType: isPhoto ? "jpg" : dt.split(",")[0].split("/")[1].split(";")[0],
        product: "diy",
        base64Format: isPhoto ? dt :  dt.split(",")[1],
        documentNumber: selectedDocumentMasterData.isMandatoryDocNumber ? documentNumber : '',
        documentExpiryDate: selectedDocumentMasterData.isMandatoryDocExpiryDate ? documentExpiryDate : '',
        latitude:  isIPV || (proofType.id == "Photo") ? Number(latitude) : "",
        longitude:  isIPV || ( proofType.id == "Photo") ? Number(longitude) : "",
        count:data && (data?.is_valid == 1 ? data?.successCounter :  data?.failureCounter),
        isAINXTLivelinessPass: data && (data?.is_valid == 1 ? true : false),
        isReUpload:(getCookie("isEmailMobileVerficationFailed") == true) ? true : false,
        isOcrRequired: isOcrRequired || false,
        isIPV
      }))
      uploadDocument(outData, images)
      if(!isIPV) {
        setProofs({ proofType: "image", data: images })
      }
    }
  }

  function uploadPdfProof(pdfData, documentNumber, documentExpiryDate,isOcrRequired) {
    if (pdfData && pdfData.data !== null) {
      let outData = [{
        pageNo: "1",
        pan: "",
        uploadId: "1",
        docTypeCode: proofType.id,
        docMId: selectedDocumentMasterData.id,
        type: proofType.type,
        objectionId: "",
        fileType: "pdf",
        product: "diy",
        base64Format: pdfData?.data.split(",")[1],
        documentNumber: selectedDocumentMasterData.isMandatoryDocNumber ? documentNumber : '',
        documentExpiryDate: selectedDocumentMasterData.isMandatoryDocExpiryDate ? documentExpiryDate : '',
        isReUpload:(getCookie("isEmailMobileVerficationFailed") == true) ? true : false,
        isOcrRequired: isOcrRequired || false
      }]
      uploadDocument(outData)
      setProofs({ proofType: "pdf", ...pdfData || {} })
    } else {
      handleClose()
    }
  }

  function uploadVideoProof(data) {
    if (data && data.length > 0) {
      var outData = data.map((dt, i) => dt && ({
        "pageNo": (i + 1),
        "uploadId": (i + 1),
        "docTypeCode": proofType.code,
        "docMId": 35,
        "type": "holder1",
        "latitude": "",
        "longitude": "",
        "objectionId": "",
        "fileType": dt.split(",")[0].split("/")[1].split(";")[0],
        "product": "diy",
        "base64Format": dt.split(",")[1],
        "isReUpload":(getCookie("isEmailMobileVerficationFailed") == true)? true : false
      }))
      uploadDocument(outData)
      setProofs({ proofType: "video", data })
    }
  }

  const proofPopup = () => {
    return (
      <ProofDialog
        onFile={onFile}
        open={popupType === "master"}
        data={proofType.code || ''}
        handleClose={handleClose}
        setSnackBar={setSnackBar}
        dialogTitle={documentTypePerName[proofType.id]}
        setSelectedDocumentMasterData={setSelectedDocumentMasterData}
        getDocumentTypeURL={config.documentMaster + (masterId || '2')}
        limitPdfPages={limitPdfPages}
      />
    )
  }

  const togglePanFailPopup = () => {
    setShowFailPopup({ ...showFailPopup, showPopup: !showFailPopup.showPopup })
  }

  const handleKycReload = () => {
    togglePanFailPopup()
    window.location.reload();
  }

  const failedApiPopup = () =>{
    return (
      <>
        {showFailPopup.showPopup && <Dialog
        open={showFailPopup.showPopup}
        maxWidth={"md"}
    >
        <DialogTitle dontShowCloseIcon>
          <Grid container direction={"column"} alignItems={"center"} justifyContent="center">
            <Grid item>
              <Typography variant="h6" style={{ fontWeight: "bold", textAlign: "center" }}>{localeText?.panStatusFailMessage}</Typography>
            </Grid>
          </Grid>
        </DialogTitle>
        <DialogContent dividers css={{ textAlign: "center", margin: "0px 30px", }}>
          <Grid container direction={"column"} alignItems={"center"} justifyContent="center">
            <Grid item>
              <Typography variant="h6">{showFailPopup.showPopupMessage}</Typography>
            </Grid>
          </Grid>
          <Grid item display={"flex"} justifyContent={"flex-end"}>
              <Button variant="contained" color="primary" css={{ textTransform: "none", marginTop: "50px" }} onClick={handleKycReload}>
                {localeText?.panStatusFailBtn}
              </Button>
            </Grid>
        </DialogContent>
    </Dialog>}
      </>
    )
  }

  const imagePopup = () => {
    return (
      <>
      <ImageUpload
        setSnackBar={setSnackBar}
        handleClose={handleClose}
        deleteImage={deleteImage}
        setLoading={setLoading}
        setDocUploadLoading={setDocUploadLoading}
        open={popupType === "image"}
        imageArray={proofs?.data || null}
        uploadMessagePopup={uploadMessagePopup}
        setUploadMessagePopup={setUploadMessagePopup}
        documentUploadedDetails={documentUploadedDetails}
        selectedDocumentMasterData={selectedDocumentMasterData}
        isAddressPage={isAddressPage}
        onSave={(images, index, docNumber, expiryDate, isOcrRequired) => uploadImageProof(images, index, docNumber, expiryDate,"","","","", isOcrRequired)}
        setOcrUploadLoading={setOcrUploadLoading}
        ocrUploadLoading={ocrUploadLoading}
        showFailPopup={showFailPopup}
        setShowFailPopup={setShowFailPopup}
        setProofs={setProofs}
        proofType={proofType}
        getAllAdressData={getAllAdressData}
        isAddressDetails={isAddressDetails}
        accountOpeningType={accountOpeningType}
      />
      </>
    )
  }

  function onPdfRemove() {
    setProofs({})
    if (documentUploadedDetails?.length > 0) {
      deleteDocument(documentUploadedDetails[0]?.kycstgProofId)
      setDocumentUploadedDetails([])
      setUploadedDocuments([])
    }
  }

  const pdfPopup = () => {
    return (
      <PdfUpload
        data={proofs}
        loading={loading}
        setSnackBar={setSnackBar}
        handleClose={handleClose}
        open={popupType === "pdf"}
        onPdfRemove={onPdfRemove}
        documentUploadedDetails={documentUploadedDetails || []}
        selectedDocumentMasterData={selectedDocumentMasterData}
        setDocUploadLoading={setDocUploadLoading}
        // mandatoryData={documentMandatoryDetails}
        onUpload={(data, docNumber, expiryDate,isOcrRequired) => uploadPdfProof(data, docNumber, expiryDate,isOcrRequired)}
        onSave={(images, index, docNumber, expiryDate, isOcrRequired) => uploadImageProof(images, index, docNumber, expiryDate,"","","","", isOcrRequired)}
        setShowFailPopup={setShowFailPopup}
        setOcrLoader={setOcrLoader}
        proofType={proofType}
        getAllAdressData={getAllAdressData}
        isAddressDetails={isAddressDetails}
      />
    )
  }

  function onVideoRemove() {
    setProofs({})
    if (documentUploadedDetails?.length > 0) {
      deleteDocument(documentUploadedDetails[0]?.kycstgProofId)
      setDocumentUploadedDetails([])
      setUploadedDocuments([])
    }
  }

  function videoPopup() {
    return (
      <Popup open={popupType === "video"} fullScreen >
        <PopupTitle onClose={handleClose} />
        <DialogContent css={{ margin: "0px 30px" }}>
          <UploadVideo
            data={proofs}
            onVideoRemove={onVideoRemove}
            toggleIPVPopup={handleClose}
            uploadVideoProof={uploadVideoProof}
            documentUploadedDetails={documentUploadedDetails}
            setLoading={setLoading}
            setSnackBar={setSnackBar}
            handleClose={handleClose}
            getDocuments={props.getDocuments}
            uploadImageProof={uploadImageProof}
          />
        </DialogContent>
      </Popup>
    )
  }


  function onPreview() {
    if (proofs?.proofType) {
      setPopupType(proofs?.proofType)
    }
  }

  function handleSnackBarClose() {
    setSnackBar({})
  }

  return (
    <>
      <UploadGrid
        key={proofType.code}
        title={title}
        onPreview={onPreview}
        proofType={proofType}
        localeText={localeText}
        setSnackBar={setSnackBar}
        isSmallScreen={isSmallScreen}
        isRequired={isRequired}
        uploadDocument={proofType.code == 'IPV' ? toggleIPVPopup : handleDocumentPopup}
        uploaded={documentUploadedDetails.find(holder => holder.documentSubType.toLowerCase() == proofType.type.toLowerCase() ? true : false)}
        accountOpeningType={accountOpeningType}
      />
      {popupType ?
        popupType === "livePhotoPopup" ? <PhotoProofDialog getDocuments={props.getDocuments} setLoading={setLoading} loading={loading} setSnackBar={setSnackBar} setSelectedDocumentMasterData={setSelectedDocumentMasterData} masterId={masterId} open={popupType === "livePhotoPopup"} handleClose={handleClose} data={"Photo"} onFile={onFile} getDocumentTypeURL={config.documentMaster + masterId} uploadImageProof={uploadImageProof} /> :
        popupType === "image" ? imagePopup() :
          popupType === "pdf" ? pdfPopup() :
            popupType === "video" ? videoPopup() :
              proofPopup()
        : <></>}
      { showFailPopup && failedApiPopup()}
      {loading && <FullScreenLogoLoader />}
      {docUploadLoading && <FullScreenLogoLoader message={localeText?.documentUploadMessageScanning}/>}
      {ocrLoader && <FullScreenLoader message={true} countDownTimer={true} secondsToLoad={3.3}/>}
      {
        snackBar?.message &&
        <Snackbar
          anchorOrigin={{
            vertical: 'top',
            horizontal: 'center',
          }}
          open={snackBar.show}
          autoHideDuration={5000}
          onClose={handleSnackBarClose}
        >
          <MySnackbarContentWrapper
            onClose={handleSnackBarClose}
            variant={snackBar.type}
            message={snackBar.message}
          />
        </Snackbar>
      }
    </>
  )
}

export default Upload;